import { ReturnStatement } from '@angular/compiler';
import { Question } from '../shared/question';
import { Response } from '../shared/response';
import { ApplicationStorage } from './applicationStorage';
//@ts-ignore
import moment from 'moment';

export class Survey14DaysTrial {

    age: any;
    segment: any;
    endgame: boolean;
    surveyOutroText: any;
    keepAge: any;

    question1: Question;
    question2: Question;
    question3: Question;
    question4: Question;
    question5: Question;


    questions: Array<Question>;

    constructor(private applicationStorage: ApplicationStorage) {
        // this.surveyConsumerAgreement = false;//TODO
        this.endgame = false;

        //(0.1) 
        this.question1 = new Question(1, [],
            'Cât de mulțumit ești de experiența oferita de dispozitivul Ploom și Sobranie sticks?',
            '1 fiind cel mai mic scor și 10 fiind cel mai mare',
            'radio-inline',
            [new Response(0, '1'),
            new Response(1, '2'),
            new Response(2, '3'),
            new Response(3, '4'),
            new Response(4, '5'),
            new Response(5, '6'),
            new Response(6, '7'),
            new Response(7, '8'),
            new Response(8, '9'),
            new Response(9, '10')
            ],
            false,
            'horizontal');



        //(0.3) 
        this.question2 = new Question(2, [1],  // 1a
            'Ce apreciezi cel mai mult la experiența ta cu Ploom și Sobranie sticks?',
            '',
            'radio-free',
            [
                new Response(0, 'Potențial de risc redus* al produsului'),
                new Response(1, 'Este mai puțin deranjant pentru cei din jurul meu – fără fum, fără scrum, mai puțin miros de tutun'),
                new Response(2, 'Este cea mai apropiată experiență de fumatul tradițional'),
                new Response(3, 'Apreciez designul dispozitivului, fiind un accesoriu care mă definește și îmi completează stilul'),
                new Response(4, 'Îl pot folosi ca alternativă când fumatul tradițional e interzis și/sau nu este posibil'),
                new Response(5, 'Pentru că grupul meu de prieteni are acest obicei și îmi place să fiu alături de ei'),
                new Response(6, 'Apreciez profilul de savoare și îmi oferă satisfacție'),
                new Response(7, 'Altele')
            ],

            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '*Reducere cu 90-95%, în medie, a 9 substanțe nocive. Pe baza datelor disponibile măsurate automat, care compară 9 constituenți nocivi recomandați de către OMS pentru a fi reduși cantitativ din fumul de țigaretă , măsurați în fumul unei țigarete de referință standard/obișnuită (1R6F) și vaporii de la Ploom X Advanced.\
            Ploom X Advanced este un produs inovator pentru încălzirea tutunului și considerăm că are un potențial semnificativ ca produs cu risc redus, în comparație cu fumatul conventional. Ploom X Advanced prezintă, în medie, o diminuare cu 90-95% a nivelurilor a 9 constituenți recomandați de către Organizația Mondială a Sănătății (OMS) pentru a fi redusi în fumul de țigarete.\
            Acest lucru nu înseamnă că utilizarea Ploom X Advanced este lipsită de riscuri sau că elimină riscurile de dependență și de sănătate asociate folosirii tutunului. Niciun produs din tutun nu este lipsit de riscuri.'
        );

        this.question2.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let question1Responses = this.question1.responses.filter(r => r.selected);
            let question2SelectedIds = this.question2.responses.filter(r => r.selected)

            if (!question2SelectedIds.map(r => r.text).includes('Altele')) {
                if (this.question2.responses && this.question2.responses[7]) {
                    this.question2.responses[7].freeMessage = "";
                }
            }
            if (question1Responses.length > 0) {
                this.endgame = false;

                return true;
            } else {
                this.question2.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }


        this.question3 = new Question(3, [2],  // 1a
            'Ce ai îmbunătăți la experiența Ploom?',
            '',
            'radio-free',
            [new Response(0, 'Varietate de sortimente – intensități și profiluri de savoare variate'),
            new Response(1, 'Forma, design-ul dispozitivului'),
            new Response(2, 'Funcționalitatea, caracteristicile tehnice ale dispozitivului (de ex., durata sesiunii, numărul de sesiuni consecutive, performanța bateriei etc.)'),
            new Response(3, 'Experiența să fie la fel de satisfăcătoare precum fumatul tradițional'),
            new Response(4, 'Ușurința de a găsi produsele Ploom în magazinele pe care le frecventez'),
            new Response(5, 'Altele'),


            ],
            false,
            'horizontal'
        );

        this.question3.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let question2Responses = this.question2.responses.filter(r => r.selected).map(r => r.text);
            let question3SelectedIds = this.question3.responses.filter(r => r.selected)

            if (!question3SelectedIds.map(r => r.text).includes('Altele')) {
                if (this.question3.responses && this.question3.responses[5]) {
                    this.question3.responses[5].freeMessage = "";
                }
            }
            if (question2Responses.includes('Altele')) {
                if (this.question2.responses?.[7]?.freeMessage) {
                    return true;
                }
                else { return false; }
            } else if (question2Responses.length > 0) {
                return true;
            } else {
                this.question3.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }





        this.question4 = new Question(4, [3],  // 1a
            'Vei continua să folosești Ploom?',
            '',
            'radio',
            [new Response(0, 'Da'),
            new Response(1, 'Nu')
            ],
            false,
            'horizontal'
        );

        this.question4.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let question3Responses = this.question3.responses.filter(r => r.selected).map(r => r.text);
            if (question3Responses.includes('Altele')) {
                if (this.question3.responses?.[5]?.freeMessage) {
                    return true;
                }
                else { return false; }
            } else if (question3Responses.length > 0) {
                return true;
            } else {
                this.question4.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }



        this.question5 = new Question(5, [4],  // 1a
            'Cum apreciezi programul de testare în raport cu următoarele aspecte?',
            '',
            'radio',
            [new Response(0, 'Termenul extins de testare'),
            new Response(1, 'Calitatea Asistenței în timpul programului de testare'),
            new Response(2, 'Lipsa de angajament la achiziție')
            ],
            false,
            'horizontal'
        );

        this.question5.render = () => {
            let question4Responses = this.question4.responses.filter(r => r.selected);

            if (question4Responses.length > 0) {
                this.endgame = false;

                return true;
            } else {
                this.question5.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;
        }


        this.questions = [this.question1, this.question2, this.question3, this.question4, this.question5];

        // console.log(this.questions)

    }


    getQuestions(): Array<Question> {
        return this.questions;
    }






}




